// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3NWv0","filesListContainer":"PosDisputesFiles_filesListContainer__PLzc8","filesButton":"PosDisputesFiles_filesButton__18BTd"};